import React from "react"
import { Link } from "gatsby"

import Layout from './layout.js'

const PostPage = (props) => (
    <Layout {...props} icon='post' />
)

export default PostPage
